<form *ngIf="notification" [formGroup]="editForm!" class="fixed-width-labels" novalidate>

    <div class="p-inputgroup">
        <span class="p-inputgroup-addon">Notification Type</span>
        <p-dropdown formControlName="Type" [options]="typeChoices" scrollHeight="50vh" appendTo="body">
            <ng-template pTemplate="selectedItem"><div>{{typeLabel}}</div></ng-template>
        </p-dropdown>
        <div *ngIf="notification.IsAssociatedWithContentItem" class="associated-with-event">(associated with news/event)</div>
    </div>

    <ng-container *ngIf="editForm!.get('Type')!.value === NotificationType.Email">
        <div class="p-inputgroup">
            <span class="p-inputgroup-addon">Subject</span>
            <input type="text" pInputText placeholder="Subject (required)" formControlName="Title">
        </div>
        <div *ngIf="editForm!.get('Title')!.value" class="character-count">{{editForm!.get('Title')!.value.length}} of {{titleMaxLength}}</div>
        <mycampapp-form-input-field-error [text]="TitleValidationMessage"></mycampapp-form-input-field-error>
    </ng-container>

    <div class="p-inputgroup vertical text">
        <span class="p-inputgroup-addon">Message</span>
        <textarea *ngIf="editForm!.get('Type')!.value !== NotificationType.Email" pInputTextarea formControlName="Text" class="description-text-area"
                  [style]="{'min-height': '80px'}" [rows]="deviceManager.isMobile ? 6 : 3" [autoResize]="!deviceManager.isMobile"></textarea>
        <p-editor *ngIf="editForm!.get('Type')!.value === NotificationType.Email" #htmlEditor formControlName="HtmlText" [style]="{'height': '300px', 'opacity': notification.IsPublished ? '0.6' : '1'}"
                  (onTextChange)="onHtmlTextChanged($event)" [readonly]="notification.IsPublished" [modules]="quillModules">
            <p-header>
                <span class="ql-formats">
                    <select class="ql-header" tabindex="-1">
                        <option value="1" tabindex="-1">Heading</option>
                        <option value="2" tabindex="-1">Subheading</option>
                        <option selected tabindex="-1">Normal</option>
                    </select>
                    <select class="ql-font" tabindex="-1">
                        <option selected tabindex="-1">Sans Serif</option>
                        <option value="serif" tabindex="-1">Serif</option>
                        <option value="monospace" tabindex="-1">Monospace</option>
                    </select>
                </span>
                <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                </span>
                <span class="ql-formats">
                    <select class="ql-size" title="Size">
                        <option value="small">Small</option>
                        <option selected>Medium</option>
                        <option value="large">Large</option>
                        <option value="huge">Extra Large</option>
                    </select>
                </span>
                <span class="ql-formats">
                    <select class="ql-color" tabindex="-1"></select>
                    <select class="ql-background" tabindex="-1"></select>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered" aria-label="Ordered List" tabindex="-1"></button>
                    <button class="ql-list" value="bullet" aria-label="Unordered List" tabindex="-1"></button>
                    <select class="ql-align" tabindex="-1">
                        <option selected tabindex="-1"></option>
                        <option value="center" tabindex="-1"></option>
                        <option value="right" tabindex="-1"></option>
                        <option value="justify" tabindex="-1"></option>
                    </select>
                </span>
                <span class="ql-formats upload-to-cloud">
                    <button class="ql-link" aria-label="Insert Link" tabindex="-1"></button>
                    <button class="ql-image" aria-label="Insert Image" tabindex="-1"></button>
                    <!--                    <button class="ql-code-block" aria-label="Insert Code Block" tabindex="-1"></button>-->
                </span>
                <span class="ql-formats">
                    <button class="ql-clean" aria-label="Remove Styles" tabindex="-1"></button>
                </span>
            </p-header>
        </p-editor>
        <input #fileInput type="file" accept=".jpg,.jpeg,.png" style="display: none;" (change)="onUploadImage($event)" />
        <span *ngIf="ImageValidationMessage" class="text-danger" >{{ImageValidationMessage}}</span>
        <div *ngIf="editForm!.get('Text')!.value" class="character-count">{{editForm!.get('Text')!.value.length}} of {{textMaxLength}}</div>
    </div>
    <mycampapp-form-input-field-error [text]="TextValidationMessage"></mycampapp-form-input-field-error>

    <div *ngIf="editForm!.get('Type')!.value === NotificationType.Sms && organization.IsMMSEnabled" class="p-inputgroup">
        <span class="p-inputgroup-addon">MMS Image</span>
        <mycampapp-select-images #selectImage [photoUrl]="notification.MediaUrl" [recommendedWidth]="750" [recommendedHeight]="500" [disabled]="disabled" (changed)="onImageChanged()"></mycampapp-select-images>
    </div>

    <div *ngIf="editForm!.get('Type')!.value === NotificationType.Email" class="p-inputgroup">
        <span class="p-inputgroup-addon">PDF</span>
        <mycampapp-select-pdf #selectPdf [pdfUrl]="editForm!.get('PdfUrl')!.value" (changed)="onPdfChanged()" [disabled]="disabled || !allowPdf"></mycampapp-select-pdf>
    </div>
    <div *ngIf="editForm!.get('Type')!.value === NotificationType.Email && !allowPdf" class="disallow-pdf">Use the Notification screen to attach a PDF to the Notification.</div>

    <div *ngIf="editForm!.get('Type')!.value !== NotificationType.Sms || organization.SmsYearlyLimit === -1" class="date-area">
        <div class="date-header">
            <div>Send Dates</div>
            <button pButton pRipple type="button" class="p-button-rounded p-button-sm" icon="pi pi-plus" label="Add Date" (click)="onAddDate()" [disabled]="ScheduledDateTimes.invalid || notification.AllSent"></button>
        </div>
        <div class="date-list">
            <div formArrayName="ScheduledDateTimes" *ngFor="let control of ScheduledDateTimes.controls; let i = index" class="send-date">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">Send Date</span>
                    <p-calendar [formControl]="$any(control)" appendTo="body" [showTime]="true" hourFormat="12" [stepMinute]="10" panelStyleClass="compressed"></p-calendar>
                </div>
                <button *ngIf="(i !== 0 || ScheduledDateTimes.controls.length > 1) && isControlEnabled(control)" pButton type="button" class="p-button-warning" icon="pi pi-trash" (click)="onDeleteDate(i)"></button>
                <span class="sent-info">{{getNumberOfSentUsers(i)}}</span>
                <mycampapp-form-input-field-error [text]="ScheduledDateValidationMessage[i]"></mycampapp-form-input-field-error>
            </div>
        </div>
    </div>

    <div class="input-error-group">
        <div *ngIf="editForm!.get('Type')!.value === NotificationType.Push" class="p-inputgroup sound-group">
            <span class="p-inputgroup-addon">Sound</span>
            <p-dropdown formControlName="Sound" [options]="soundChoices" scrollHeight="50vh" appendTo="body"></p-dropdown>
            <button *ngIf="editForm!.get('Sound')!.value !== 'default'" pButton pRipple type="button" class="p-button-rounded sound-button"
                icon="pi pi-play" (click)="onPlaySound()"></button>
        </div>
    </div>

    <div *ngIf="notification.IsCampSiteCreated" class="campsite-count">
        Number of CampSite Users: {{notification.NumCampSiteMembers}} of {{memberCountResult?.TotalMembers}} Users
    </div>

    <div *ngIf="!notification.IsCampSiteCreated" class="form-multi-input-per-line" [class.space-evenly]="editForm!.get('Type')!.value === NotificationType.Email">
        <div *ngIf="!hideCategories" class="categories">
            <button pButton pRipple type="button" class="p-button-rounded choose-categories-button" (click)="onChooseCategories()"
                    [disabled]="disabled || notification.IsAssociatedWithContentItem">
                <fa-icon icon="people-group" size="1x"></fa-icon><span style="margin-left: 10px;">Categories</span>
            </button>
            <span *ngIf="memberCountResult" class="category-count">{{memberCountResult.MembersMatchingCategories}} of {{memberCountResult.TotalMembers}} Users</span>
            <button *ngIf="memberCountResult" pButton type="button" class="p-button-rounded p-button-danger no-label small" (click)="onRemoveCategories()" style="margin-left: 3px;"
                    [disabled]="disabled || notification.IsAssociatedWithContentItem">
                <fa-icon icon="trash" size="1x"></fa-icon>
            </button>
            <span *ngIf="editForm!.get('Type')!.value === NotificationType.Sms" class="sent-info">{{getNumberOfSentUsers(0)}}</span>
        </div>
        <div *ngIf="editForm!.get('Type')!.value === NotificationType.Email"  class="p-inputgroup">
            <span class="p-inputgroup-addon">Registered?</span>
            <p-dropdown formControlName="RegistrationFilter" [options]="registeredChoices" class="medium-width" scrollHeight="50vh" appendTo="body"></p-dropdown>
        </div>
    </div>

    <div *ngIf="editForm!.get('Type')!.value === NotificationType.Sms" class="push-message-area">
        <div class="sent-immediately" *ngIf="organization.SmsYearlyLimit !== -1">
            This Text Message will be sent immediately.
        </div>
        <div class="govt-warning">
            <b>WARNING:</b> Text messages (SMS) are perceived as are more intrusive and “spammy” than Mobile Push notifications. Also SMS are highly regulated
            by the FCC and should not be used for marketing purposes. Use SMS only for last minute alerts and urgent transactional messages. Use Mobile Push
            notifications rather than Text Messaging for news flashes, friendly reminders, and to drive engagement.
            <div><b>INFO:</b> The Federal Communications Commission has issued rules to ensure consumer protection in regard to commercial SMS messaging;
                that is the sending of marketing text messages to mobile phones. The Telephone Consumer Protection Act (TCPA) and CAN-SPAM Act are the
                applicable laws regulating marketing using SMS messaging in the United States of America.</div>
            <div><b>COMPLIANCE:</b> App users can easily opt-out of receiving text messaging in their Settings. Non-app users should contact the camp admin to have their
                cell number removed from the User contact list in the myCAMPapp content management portal.</div>
        </div>
    </div>
</form>

<mycampapp-select-categories-dialog *ngIf="showSelectCategoriesDialog" (categoriesSelected)="onCategoriesSelected($event)" [selectedCategoryIds]="selectedCategoryIds"></mycampapp-select-categories-dialog>
